import React from 'react'
import ResetPasswordForm from '../forms/ResetPasswordForm'
import CustomLink from '../components/CustomLink'
import AuthLayout from './AuthLayout'
import globals from '../globals'

class ResetPassword extends React.Component {
    constructor (props) {
        super(props)

        this.state = {
            token: '',
            loginName: '',
            validToken: false
        }
    }

    componentDidMount () {
        this.validateToken()
    }

    validateToken () {
        const urlParams = new URLSearchParams(window.location.search)
        const urlToken = urlParams.get('token')
        const loginName = urlParams.get('login_name')
        const validToken = urlToken && loginName

        this.setState({
            token: urlParams.get('token'),
            loginName: urlParams.get('login_name'),
            validToken: validToken
        })
    }

    render () {
        const InvalidToken = (
            <div className='p-5 text-center'>
                <p>Sorry your token is missing or invalid. Please retry clicking on the link in your email.</p>
                <p>Alternatively you can <CustomLink to='/forgot-password'>click here</CustomLink> to go back to the forgot password page to try resending the email.</p>
            </div>
        )

        return (
            <AuthLayout
                title='Reset your password'
                description='Enter your new password and password confirmation below'
            >
                {!this.state.validToken
                    ? InvalidToken
                    : <ResetPasswordForm
                            token={this.state.token}
                            loginName={this.state.loginName}
                            handleSuccess={() => globals.pushEvent('ResetPasswordSubmit')}
                      />}
                <div className='row'>
                    <div className='col-12 text-center mt-5'>
                        <small>Return back to <CustomLink to='/login'>My Exetel</CustomLink></small>
                    </div>
                </div>
            </AuthLayout>
        )
    }
}

export default ResetPassword



// WEBPACK FOOTER //
// ./resources/js/auth/ResetPassword.js